import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { LowerCasePipe, NgClass } from '@angular/common';

@Component({
  selector: 'ui-form-number-input',
  imports: [LowerCasePipe, NgClass],
  templateUrl: './form-number-input.component.html',
  styleUrl: './form-number-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormNumberInputComponent {
  value = model<number>(0);
  min = input<number | null>(null);
  max = input<number | null>(null);
  step = input<number>(1);
  placeholder = input<string>('');
  prefix = input<string>('');
  suffix = input<string>('');
  dataCy = input<string>('');

  protected readonly hasAddon = computed(
    () => !!this.prefix() || !!this.suffix(),
  );

  protected onInput(raw: string): void {
    if (raw === '') {
      this.value.set(this.min() ?? 0);
      return;
    }
    const parsed = Number(raw);
    if (Number.isNaN(parsed)) {
      return;
    }
    this.value.set(this.clamp(parsed));
  }

  private clamp(value: number): number {
    const min = this.min();
    const max = this.max();
    let next = value;
    if (min !== null) {
      next = Math.max(min, next);
    }
    if (max !== null) {
      next = Math.min(max, next);
    }
    return next;
  }
}
